import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'angular-admin-lte';
import { AlertService } from './_services/index';
import { AuthenticationService,ProfileService,LoaderService} from "./_services/index";
import { environment } from '../environments/environment';
import { CookieService } from 'ngx-cookie-service';
import {Router} from "@angular/router"
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    private currentRoute: string;
    public customLayout: boolean;
    public profile:any;
    public data:any;
    public alerts:any;
    public loading = false;
    copyright = {
        env: environment.API_ENV,
        version: environment.APP_VERSION,
        year: environment.YEAR
    }
    constructor(
        private router: Router,
        private cookieService: CookieService,
        private loaderService: LoaderService,
        private layoutService: LayoutService,
        public profileService: ProfileService,
        public authService: AuthenticationService,
        public alertService:AlertService
    ) {
        this.loaderService.isLoading.subscribe((v) => {
            if(v){
                this.loading = true;
            }else{
                setTimeout(() => {
                    this.loading = false;
                },3000)
            }
        });
        this.currentRoute= window.location.pathname;

    }
    logout(){
        if(this.router.url != '/iniciar-sesion' && this.router.url != '/encuesta'){
            this.authService.logout().subscribe(response => {
                this.router.navigate(['/'])
            }, error => {
            })
        }
    }
    ngOnInit() {
        let cookieExists: boolean = this.authService.checkAuthentication().authorized;
        if(!cookieExists && (this.currentRoute != '/iniciar-sesion' && this.currentRoute != '/encuesta' && this.currentRoute.split("/")[1] != 'encuesta')){
            this.logout();
        }
        this.alertService.getAlert().subscribe(response=>{
            this.alertService.alerts.subscribe(value=>{
                this.data = value;
                this.alerts = value;
            })
        })
        this.layoutService.isCustomLayout.subscribe((value: boolean) => {
            this.customLayout = value;
        });
        let token = this.authService.checkAuthentication();
        if (token.token != "incontrol") {
            this.profileService.getProfile().subscribe(response => {
                this.profile = response;
            }, error => {
            })
        }
    }
}
